import apiClient from '../api/api';
import { API_ENDPOINTS } from '../api/api.config';

export interface InviteListParams {
  skip?: number;
  limit?: number;
  email?: string;
}

export interface InviteMetrics {
  total_invites: number;
  total_pending: number;
  total_accepted: number;
  total_registered: number;
  success_rate: string;
}

class Inviteusers {
async getInvites(params?: InviteListParams): Promise<any> {
    try {
        const response = await apiClient.post(API_ENDPOINTS.USERS.INVITE_USER, params);
        return response.data;
    } catch (error) {
        console.error('Error fetching invites:', error);
        throw error;
    }
}

async inviteUser(inviteData: any): Promise<any> {
  try {
    const response = await apiClient.post(API_ENDPOINTS.USERS.INVITE, inviteData);
    return response.data;
  } catch (error) {
    console.error("Error inviting user:", error);
    throw error;
  }
}

async reinvite(inviteId: string): Promise<any> {
    try {
        const response = await apiClient.post(API_ENDPOINTS.USERS.USER_REINVITE + `/${inviteId}`);
        return response.data;
    } catch (error) {
        console.error('Error reinviting invite:', error);
        throw error;
    }
}

 async revokeInvite(inviteId: string): Promise<any> {
    try {
        const response = await apiClient.post(API_ENDPOINTS.USERS.USER_REVOKE + `/${inviteId}`);
        return response.data;
    } catch (error) {
        console.error('Error revoking invite:', error);
        throw error;
    }
}

async userGroupMapping(user: any): Promise<any> {
  try {
    const response = await apiClient.post(API_ENDPOINTS.USERS.USER_GROUP_MAPPING, user, );
    return response.data; // { success, code, data: { totalUsers, users } }
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }

}
}

export const inviteusersService = new Inviteusers();
export default inviteusersService;